import * as React from "react";
import { useNavigate } from "react-router";
import Button from "../../buttons/Button";

import "./Forbidden.scss";

/**
 * Forbidden component
 * @module
 */
const Forbidden = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/")
  }

  return (
    <div className="forbidden">
      <h1>Ups!</h1>
      <div>Je nám to ľúto, ale požadovaná stránka neexistuje alebo na ňu nemáte oprávnenie!</div>
      <Button
        primary
        label="Návrat na domovskú stránku"
        onClick={handleBack}
      />
    </div>
  );

}

export default Forbidden;